import { calcSpacing } from 'src/components/foundations';
import styled from 'styled-components';

export interface FlexViewPrimitiveProps extends React.HTMLAttributes<HTMLDivElement> {
  $gap: number;
  $position?: 'relative' | 'absolute' | 'fixed' | 'sticky';
  $direction?: 'row' | 'column' | 'row-reverse' | 'column-reverse';
  $justifyContent?:
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'space-between'
    | 'space-around'
    | 'space-evenly';
  $alignItems?: 'stretch' | 'flex-start' | 'flex-end' | 'center' | 'baseline';
  $positionValues?: {
    top?: number;
    right?: number;
    bottom?: number;
    left?: number;
  };
  $zIndex?: number;
  $padding?: {
    top?: number;
    right?: number;
    bottom?: number;
    left?: number;
  };
  $margin?: {
    top?: number;
    right?: number;
    bottom?: number;
    left?: number;
  };
}

export const FlexViewPrimitive = styled.div<FlexViewPrimitiveProps>`
  display: flex;
  flex-direction: ${({ $direction = 'row' }) => $direction};
  justify-content: ${({ $justifyContent = 'flex-start' }) => $justifyContent};
  align-items: ${({ $alignItems = 'stretch' }) => $alignItems};
  gap: ${(props) => calcSpacing(props.$gap)}px;
  padding: ${({
    $padding: { top = 0, right = 0, bottom = 0, left = 0 } = {},
  }) =>
    `${calcSpacing(top)}px ${calcSpacing(right)}px ${calcSpacing(
      bottom,
    )}px ${calcSpacing(left)}px`};
  margin: ${({ $margin: { top = 0, right = 0, bottom = 0, left = 0 } = {} }) =>
    `${calcSpacing(top)}px ${calcSpacing(right)}px ${calcSpacing(
      bottom,
    )}px ${calcSpacing(left)}px`};
  position: ${({ $position = 'static' }) => $position};
  top: ${({ $positionValues: { top = 0 } = {} }) => calcSpacing(top)}px;
  right: ${({ $positionValues: { right = 0 } = {} }) => calcSpacing(right)}px;
  bottom: ${({ $positionValues: { bottom = 0 } = {} }) =>
    calcSpacing(bottom)}px;
  left: ${({ $positionValues: { left = 0 } = {} }) => calcSpacing(left)}px;
  z-index: ${({ $zIndex = 0 }) => $zIndex};
`;
